import React from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { Sparkles, LayoutDashboard, LogOut, MessageCircle } from "lucide-react";
import { useAuth } from "@/context/AuthContext";
import { Button } from "@/components/ui/button";

const WHATSAPP_FALLBACK = "919630024060";

export const Header = ({ whatsappNumber }) => {
  const { user, logout } = useAuth();
  const location = useLocation();
  const navigate = useNavigate();
  const number = whatsappNumber || WHATSAPP_FALLBACK;

  const quickConnect = () => {
    const msg = encodeURIComponent("Hi Soulful Invites! I'd love to know more about your e-invites.");
    window.open(`https://wa.me/${number}?text=${msg}`, "_blank");
  };

  return (
    <header
      data-testid="site-header"
      className="sticky top-0 z-50 backdrop-blur-md bg-[#FAF6F0]/85 border-b border-amber-500/25"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 h-20 flex items-center justify-between">
        <Link to="/" data-testid="brand-logo" className="flex items-center gap-2.5 group">
          <span className="grid place-items-center h-11 w-11 rounded-xl bg-gradient-to-br from-amber-500 via-yellow-400 to-amber-600 shadow-md shadow-amber-500/30">
            <Sparkles className="h-5 w-5 text-white" strokeWidth={2.2} />
          </span>
          <span className="leading-tight">
            <span className="block font-serif text-xl font-bold text-amber-950 tracking-tight">
              Soulful Invites
            </span>
            <span className="block text-[10px] tracking-[0.28em] uppercase text-amber-700 font-semibold">
              Luxury E-Invitations
            </span>
          </span>
        </Link>

        <div className="flex items-center gap-2 sm:gap-3">
          <Button
            data-testid="header-whatsapp-connect"
            onClick={quickConnect}
            variant="ghost"
            className="hidden sm:inline-flex text-emerald-700 hover:text-emerald-800 hover:bg-emerald-50 font-medium"
          >
            <MessageCircle className="h-4 w-4 mr-1.5" /> Quick Connect
          </Button>

          {user && user !== false ? (
            <>
              <Button
                data-testid="header-dashboard-link"
                onClick={() => navigate("/admin")}
                variant="outline"
                className="border-amber-500/40 text-amber-900 hover:bg-amber-50"
              >
                <LayoutDashboard className="h-4 w-4 sm:mr-1.5" />
                <span className="hidden sm:inline">Dashboard</span>
              </Button>
              <Button
                data-testid="header-logout-btn"
                onClick={() => { logout(); navigate("/"); }}
                variant="ghost"
                className="text-stone-600 hover:text-red-700 hover:bg-red-50"
              >
                <LogOut className="h-4 w-4" />
              </Button>
            </>
          ) : (
            location.pathname !== "/admin/login" && (
              <Button
                data-testid="admin-login-button"
                onClick={() => navigate("/admin/login")}
                className="bg-amber-950 hover:bg-amber-900 text-amber-50 font-medium"
              >
                Admin Login
              </Button>
            )
          )}
        </div>
      </div>
    </header>
  );
};
